import { render, staticRenderFns } from "./MenuViewCard.vue?vue&type=template&id=74d56d92&scoped=true&"
import script from "./MenuViewCard.vue?vue&type=script&lang=js&"
export * from "./MenuViewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d56d92",
  null
  
)

export default component.exports